<div class="form-group">
  <!-- Label -->
  <label *ngIf="config.label" [for]="config.label">
    {{ config.label }}
    <span *ngIf="config.isRequired">*</span>
  </label>

  <!-- Single Select Dropdown -->
  <p-dropdown *ngIf="!config.isMultiSelect" [formControl]="config.formControl" [options]="config.options"
    [placeholder]="config.placeholder" [ngClass]="{'ng-invalid': config.formControl?.invalid, 'ng-dirty': config.formControl?.dirty}"
    (onChange)="onSelectionChange($event)">
  </p-dropdown>

  <!-- Multi Select Dropdown -->
  <p-multiSelect *ngIf="config.isMultiSelect" [formControl]="config.formControl" [options]="config.options"
    [placeholder]="config.placeholder" [ngClass]="{'ng-invalid': config.formControl?.invalid, 'ng-dirty': config.formControl?.dirty}"
    (onChange)="onSelectionChange($event)">
  </p-multiSelect>

  <!-- Error Message -->
  <span *ngIf="errorMessage" class="text-danger">
    {{ errorMessage }}
  </span>

  <!-- Hint Text -->
  <span *ngIf="!errorMessage && config.hint" class="text-secondary">
    {{ config.hint }}
  </span>
</div>
